import React from "react";
import "../../css/toastView.css";
import Heading from "../../components/Heading";
import ContentPage from "../../components/content-page";
import Meta from "../../components/meta";
import PropTypes from "prop-types";
import ReactPixel from "react-facebook-pixel";
import Link from "gatsby-link";
import Modal from "../../components/Modal";
import Slider from "react-slick";
import "../../components/slick.css";
import "../../components/slick-theme.css";
import LinkedInTag from "react-linkedin-insight";

const icon1 = "https://winpeforum.com/assets/elements/AnkitaBalotia.png";
const icon2 = "https://winpeforum.com/assets/elements/CharuGulati.jpg";
const icon3 = "https://winpeforum.com/assets/elements/Hemangi.jpg";
const icon4 = "https://winpeforum.com/assets/elements/KrunaliShah.jpg";
const icon5 = "https://winpeforum.com/assets/elements/NishthaKohli.jpg";
const icon6 = "https://winpeforum.com/assets/elements/ParitaAshar.jpg";
const icon7 = "https://winpeforum.com/assets/elements/PoojaParmar.jpg";
const icon8 = "https://winpeforum.com/assets/elements/PrachiMarwah.jpg"; 
const icon9 = "https://winpeforum.com/assets/elements/SanjnaTulsiani.jpg";
const icon10 = "https://winpeforum.com/assets/elements/SarikaSaxena.jpg";
const icon11 = "https://winpeforum.com/assets/elements/ShwetaLaddha.jpg";
const icon12 = "https://winpeforum.com/assets/elements/SnigdhaJain.jpg";
 

let duration = 400;

const TeamModal = ({ activeItem, show, onHide }) => {
  return (
    <Modal
      direction=""
      className="teamdetails__wrapper"
      show={show}
      onHide={onHide}
    >
      <Modal.Header>
        <div className="head_section">
          <span className="item_name">{activeItem.name}</span>
          <div
            className="item_des"
            dangerouslySetInnerHTML={{ __html: activeItem.post }}
          ></div>
        </div>
        <span className="cross pull-right">
          <i onClick={onHide} className="fa fa-times" />
        </span>
      </Modal.Header>
      <Modal.Body>
        <div className="item__desc">
          <div dangerouslySetInnerHTML={{ __html: activeItem.desc }}></div>
        </div>
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  );
};

TeamModal.propTypes = {
  activeItem: PropTypes.object,
  show: PropTypes.object,
  onHide: PropTypes.object,
};

export class SheShines extends React.Component {
  constructor(args) {
    super(args);
    this.state = {
      slidesToShow: 1,
      activeItem: {},
      isShow: false,
      defaultStyle: {
        transition: `opacity ${duration}ms ease-in-out`,
        opacity: 0,
      },
    };
    this.Speaker2 = [
     
  
  
        {
          imgUrl: icon1,
          desc: `<div>
Ankita Balotia is Vice President on the Investment team at Fireside Ventures, working hands-on with six portfolio companies—including Pilgrim, Kapiva, Sweet Karam Coffee, and Frubon—on growth, product, and go-to-market. Prior to Fireside, she was an investor at Venture Highway (General Catalyst India), backing multiple consumer technology businesses across stages. Ankita began her career in management consulting, spending over five years at Bain & Company and Strategy& (formerly Booz & Company), where she advised clients in consumer tech, telecom, real estate, and healthcare on strategy and execution. She holds a B.Tech in Computer Science from IIT Delhi and an MBA from IIM Ahmedabad.

 
          </div>`,
          name: "Ankita Balotia",
          post: `<div>Vice President on the Investment team<br/>Fireside Ventures


          </div>`,
        },
  ];
    this.Speaker1 = [
        {
          imgUrl: icon1,
          desc: `<div>
Ankita Balotia is Vice President on the Investment team at Fireside Ventures, working hands-on with six portfolio companies—including Pilgrim, Kapiva, Sweet Karam Coffee, and Frubon—on growth, product, and go-to-market. Prior to Fireside, she was an investor at Venture Highway (General Catalyst India), backing multiple consumer technology businesses across stages. Ankita began her career in management consulting, spending over five years at Bain & Company and Strategy& (formerly Booz & Company), where she advised clients in consumer tech, telecom, real estate, and healthcare on strategy and execution. She holds a B.Tech in Computer Science from IIT Delhi and an MBA from IIM Ahmedabad.

 
          </div>`,
          name: "Ankita Balotia",
          post: `<div>Vice President on the Investment team<br/>Fireside Ventures


          </div>`,
        },
       
        {
          imgUrl: icon2,
          desc: `<div>
Charu Gulati is the Chief Human Resources Officer (CHRO) at Everstone Group, India, where she plays a pivotal strategic and operational role in aligning the firm’s talent agenda with its investment objectives. She leads human capital initiatives across the firm and its portfolio companies, focusing on leadership assessment, organizational design, succession planning, and culture building. <Br/><Br/>
Before joining Everstone, Charu served as Director of Human Resources at IDFC Bank, where she was responsible for HR strategy and execution across both retail and wholesale banking operations. Earlier in her career, she spent over 15 years at Genpact, where she held leadership roles in operations and HR, managing finance and accounting offshore businesses across a diverse range of industries. <br/><Br/>
Charu holds a Diploma in Hotel Management from the Institute of Hotel Management, Catering Technology and Applied Nutrition, and a Post Graduate Certificate in Human Resources from XLRI, Jamshedpur.


          </div>`,
          name: "Charu Gulati",
          post: `<div>CHRO<br/> Everstone Group, India

          </div>`,
        },
        {
            imgUrl: icon3,
          desc: `<div>
    Hemangi has been a seasoned banker with 14 years of experience across investment and corporate banking. At Trifecta Capital, Hemangi is a Director for Venture Debt Investments, leading investments with startups like Rebel Foods, Bharatpe, Rupeek, Moneyview, Alt Mobility, Practo, and Slurrp Farm. Previously  at ICICI Bank, she led startup and tech coverage across Western India and before that at  Nomura, she worked on M&A and ECM deals across Southeast Asia and the U.S. An angel investor and advisor, she brings a 360° approach to founder and investor partnerships. She holds an MBA from NMIMS.  

          </div>`,
          name: "Hemangi",
          post: `<div>Director for Venture Debt Investments<br/>Trifecta Capital

          </div>`,
          },
          
           {
            imgUrl: icon4,
          desc: `<div>
    Krunali Shah has been an Investor with A91 Partners for 5 years. She is involved with investments across consumer brands, financial services and technology. Prior to joining A91, Krunali was a part of the Boston Consulting Group. She has graduated from IIM Ahmedabad and is a Chartered Accountant. 


          </div>`,
          name: "Krunali Shah Pinjani",
          post: `<div>Investor<br/> A91 Partners

          </div>`,
          },
           {
            imgUrl: icon5,
          desc: `<div>
    Nishtha Kohli is based in Mumbai and is a Senior Vice President at Warburg Pincus focused on investments in India. She has been with Warburg for 5 years and has been instrumental in leading investment efforts in the BPO and IT Services sector including Warburg's recent deal, Everise ($1Bn transaction in healthcare outsourcing services). Prior to joining Warburg Pincus, she was a Vice President at Credit Suisse New York within the Global Industrials Investment Banking Division where she focused on mergers and acquisitions. Nishtha holds a BA in Mass Media and Economics from St. Xavier’s College, Mumbai, where she was a gold medalist and an MBA from The University of Chicago Booth School of Business.



          </div>`,
          name: "Nishtha Kohli",
          post: `<div>Senior Vice President<br/>Warburg Pincus

          </div>`,
          },
            {
            imgUrl: icon6,
          desc: `<div>
    Ms. Parita Ashar is a Principal at OIJIF and has 14 years of experience, including 8 years in Private Investing. She manages several of OIJIF’s investments across the Financial Services and Consumer sectors and brings full-cycle investment experience—from origination to successful exits. Parita has delivered multiple exits through IPOs and secondary transactions in OIJIF’s portfolio companies. Before joining OIJIF, Parita led research coverage of listed companies across various sectors at Ambit’s Institutional Equity Research division. She is a Chartered Accountant and a CFA Charter holde
 
          </div>`,
          name: "Parita Ashar",
          post: `<div>Principal<Br/>OIJIF
          </div>`,
          },
            {
            imgUrl: icon7,
          desc: `<div>
    Pooja Parmar is a seasoned investment professional based in Mumbai with 8 plus years of experience in venture capital. She is currently a Principal at Equanimity Investments. She looks at investments end to end right from sourcing to exit. She has led deals like Renee cosmetics, Insurance Samadhan, Edept, Navata supply chain solutions, Biva Analytics amongst others. She earlier worked at Housing.com, and PwC in the finance domain. Pooja is a Chartered accountant and has done her bachelors in commerce from University of Mumbai.

          </div>`,
          name: "Pooja Parmar",
          post: `<div>Principal<br/>Equanimity Investments

          </div>`,
          },
           {
            imgUrl: icon8,
          desc: `<div>
    Prachi is a Sr. Vice President at ChrysCapital, where she focuses on investments with particular focus on the Consumer sector. She has been with the firm since 2019 and has played a key role in evaluating fresh deals and managing portfolio companies across the consumer landscape.
 <Br/><Br/>
Prior to ChrysCapital, Prachi was with Baring Private Equity Partners India, where she worked on investments across multiple sectors. Prachi has an MBA from the Wharton School, University of Pennsylvania, She is passionate about mentorship and actively engages with young investment professionals — both within and outside ChrysCapital—to help them navigate and grow in the industry.


          </div>`,
          name: "Prachi Marwah",
          post: `<div>Sr. Vice President<br/>ChrysCapital


          </div>`,
          },
           {
            imgUrl: icon9,
          desc: `<div>
    Sanjna has 10+ years of experience across venture growth investing, investor relations and equity research.  At Iron Pillar, she has been involved in the entire deal lifecycle from sourcing, due diligence and documentation to portfolio company monitoring and exit. 
<br/><Br/>
Sanjna is a CFA® Charter holder. She holds a Masters in Commerce (Finance & Accounting) and Bachelors in Management Studies (Finance) from the University of Mumbai.


          </div>`,
          name: "Sanjna Tulsiani",
          post: `<div>Senior Vice President<br/>Iron Pillar



          </div>`,
          },
           {
            imgUrl: icon10,
          desc: `<div>
   Sarika Saxena is the Managing Partner at IAN Alpha Fund, an offshoot of the Indian Angel
Network, with over 25 years of experience across Indian, UK, and US markets. She has spent
over 20 years in the start-up, PE, and VC space.<Br/><Br/>
Her expertise includes M&amp;A (heading M&amp;A at Mphasis), cross-border transactions, debt &amp;
equity, and fund raising, notably raising $42m for Value Based Housing Corporation. Sarika
also played a pivotal role in establishing the innovative NBFC, Nfin. She holds an MBA from
the London Business School.


          </div>`,
          name: "Sarika Saxena",
          post: `<div> Managing Partner<br/>IAN Alpha Fund



          </div>`,
          },
           {
            imgUrl: icon11,
          desc: `<div>
  Shweta Laddha is the Senior Vice President and Head of Compliance & Secretarial at Multiples Private Equity Group. With over 16 years of experience spanning Compliance, Secretarial, Legal, and Investment Banking, Shweta brings a strategic and solutions-oriented approach to governance and regulatory affairs. At Multiples, she not only oversees group-level compliance but also plays a pivotal role in strengthening governance frameworks across portfolio companies.
 <br/><Br/>
Her career includes leadership roles at NIIF Infrastructure Finance Limited, Aditya Birla Capital Group, and BOB Capital Markets, where she led complex transactions including fund raising and corporate restructuring. Shweta has worked extensively with financial regulators and has built robust compliance and secretarial functions from the ground up. She holds professional qualifications as a Company Secretary, LLB, and PGDM.


          </div>`,
          name: "Shweta Laddha",
          post: `<div> Senior Vice President and Head of Compliance & Secretarial<br/>Multiples Private Equity Group



          </div>`,
          },
             {
            imgUrl: icon12,
          desc: `<div>
  Ms. Jain has 21 years of experience in capital raising, investor relations and business development across financial services and is responsible for offshore fund raise and investor relations at Ascertis Credit. Prior to joining the firm, Ms. Jain was with Kotak Investment Advisors Limited as Executive Director - Capital Raising, responsible for capital raising and investor relationships for multiple products within the Kotak alternatives platform. She has also worked with Marsh India Insurance Brokers and IL&FS Trust Company Ltd (now Vistra) providing customized risk solutions and product sales within the financial services sector.




          </div>`,
          name: "Snigdha Jain",
          post: `<div> Executive Vice President<br/>Ascertis Credit




          </div>`,
          },
    ];
 
  
  }
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    ReactPixel.init("2879175222167037");
    ReactPixel.track("ViewContent", location);
    LinkedInTag.init("2117884");
    LinkedInTag.track("2310748");
    setTimeout(() => {
      this.setState({
        defaultStyle: {
          transition: `opacity ${duration}ms ease-in-out`,
          opacity: 1,
        },
      });
    }, 500);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    const { slidesToShow } = this.state;
    // // console.log("width", window.innerWidth)
    if (window.innerWidth <= 768 && window.innerWidth > 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else if (window.innerWidth <= 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    }
  };
  togglePopUp = (item) => {
    this.setState({
      isShow: !this.state.isShow,
      activeItem: item || {},
    });
  };
  render() {
    const { defaultStyle, isShow, slidesToShow } = this.state;
    const { location } = this.props;
    let settings = {
      dots: false,
      infinite: true,
      speed: 6000,
      autoplay: true,
      slidesToShow: slidesToShow,
      slidesToScroll: slidesToShow,
      autoplaySpeed: 7000,
      arrows: true,
    };
    console.log("render", this.render1, slidesToShow);
    this.render1 = this.render1 + 1;
    return (
      <ContentPage>
        <Meta
          title="Winpe Ignite Career Talk Session"
          image={"https://winpeforum.com/api/src/templates/emailers/assets/newsletter2022.png"}
          description="Anchored in the theme Charting Your Course, the breakout conversations highlighted how Senior women across Private Equity, Early Growth- Late VC, Early-Stage VC, and Operating Roles carve distinct paths to success. "
          location={location}
        />
        <div className="section__content" style={defaultStyle}>
          <div className="toastshine_wrapper">
            <div className="back_event">
              <Link to="/events/">
                <i className="fa fa-arrow-left"> Back to Events</i>
              </Link>
            </div>
            <div className="toastshine_section">
              <div className="m_heading">Winpe Ignite Career Talk Session  </div>
              <div className="r_btm"></div>
               
 
              <div className="date_heading">
                <div className="date_heading">
                  <span>November 15, 2025</span>
                  <br/>
                  <span> <i>Online</i></span>
                </div>
              </div>
              <br/>
 
 
              <div className="top_text" style={{textAlign: 'justify'}}> 
         On 15th November 2025, we hosted another edition of Winpe’s PEVC Career Talk Series — this time diving into the theme “Charting Your Course: Lessons from Women Who’ve Redefined Success in PE/VC”<br/><br/>
There were four breakout rooms, each led by three expert speakers. The rooms covered Private Equity, Early Growth, Late VC, Early-Stage VC, and Operating Roles.<br/><br/>
Participants had the flexibility to move between breakout rooms throughout the session, allowing them to listen in on various discussions and gain a broad perspective from all the speakers.<br/><br/>
Anchored in the theme Charting Your Course, the breakout conversations highlighted how Senior women across Private Equity, Early Growth- Late VC, Early-Stage VC, and Operating Roles carve distinct paths to success. The discussions surfaced practical advice on decision-making, leadership, value creation, and building durable careers in an evolving PE/VC landscape. The session saw 95% positive feedback from the attendees! 
<br/><br/>

Catch the full recording <a href="https://www.youtube.com/playlist?list=PLu3vBoq2n-PqWON-HWyen1--uHu8R56n-" target="_blank" style={{color:'blue', textDecoration:'underline'}}>here</a><br/><br/>
 Through sessions like these, Winpe continues its mission to empower women with the tools and perspective they need to enter and thrive in the ever-evolving culture of PEVC.


<br/> 
  


<h3><b>Key Highlights:</b></h3>
<h4 style={{textDecoration:'underline'}}>Operating Roles:</h4> 
<ul>
   
    
<li><b>Own your function</b> — HR, Compliance, and Fundraising are strategic enablers, not back-end roles. Recognition comes from adding value, not seeking visibility.</li> 

<li><b>Understand the business deeply</b> — knowing the investment lifecycle end-to-end builds credibility and positions you as a true partner to deal teams.</li> 

<li><b>Influence through solutions</b> — bring alternatives, context, and judgment. Be seen as someone who helps get deals done while safeguarding the firm.</li> 

<li><b>Network with purpose</b> — meaningful conversations, LinkedIn outreach, industry forums, and small peer groups all help build mentors and advocates.</li> 

<li><b>Create your own mentorship circle</b> — seek seniors, peers, and cross-functional leaders; mentorship in operating roles is often informal and self-driven.</li> 

<li><b>Balance structure with judgment</b> — say “no” when required, but always pair it with a practical, business-aligned path forward.</li>

<li><b>Advice to women</b> — be confident, be prepared, stay curious, invest in relationships, and build expertise that makes you indispensable.
</li>
</ul>
<br/> 
<h4 style={{textDecoration:'underline'}}>Private Equity: </h4>
<ul> 
<li><b>Master the investment toolkit</b> — sourcing, sector mapping, diligence, and financial modelling shape your credibility; excellence in these basics is what accelerates you.</li>
<li><b>Build conviction the right way</b> — ask sharper questions, test assumptions, and form independent perspectives. Strong investors balance intuition with evidence.</li>
<li><b>Have a clear point of view</b> — track sectors, write theses, and debate ideas. A differentiated POV shows partners how you think and strengthens your influence.</li>
<li><b>Communicate for ICs</b> — be crisp, structured, and transparent on risks. The way you present can often matter as much as what you present.</li>
<li><b>Invest in your network </b>— founders, bankers, operators, and other investors become long-term deal-flow enablers. Your network compounds into an edge.</li>
<li><b>Learn the ‘art’ of investing</b> — pattern recognition, timing, and deal instincts come from exposure, reflection, and staying curious about how businesses evolve.</li>
<li><b>Advice to women</b> — speak with confidence, ask tough questions, claim your space, and build relationships that recognise and amplify your strengths.</li>
</ul>
<br/> 
<h4 style={{textDecoration:'underline'}}>Early Growth - Late VC</h4>
<ul>
<li><b>Combine analysis with intuition</b> — Build conviction with rigorous financial modeling, but also rely on intuition, sector patterns, and founder signals. Numbers guide you; judgment closes the deal.</li>
<li><b>Add real value</b> — Go beyond capital: help founders with hiring, strategy, and execution gaps. Be hands-on without micromanaging. Your support builds trust and improves outcomes.</li>
<li><b>Be patient but proactive</b> — Navigate periods of uncertainty by giving founders space while remaining engaged. Use your network to provide timely strategic advice.</li>
<li><b>Invest in the team, not just the idea</b> — A founder’s vision matters, but execution ability, repeatable frameworks, and the right cap table are decisive. </li>
<li><b>Earn internal credibility</b> — Complete work accurately, anticipate next steps, and provide unbiased insights. Move from executor → thought partner → strategic contributor.</li>
<li><b>Leverage mentors and networks</b> — Observe leaders you respect. Mentorship can be formal or peer-based. It shapes judgment, leadership style, and career trajectory.</li>
<li><b>Evolve your impact</b> — Start with execution, then add value, influence strategy, and eventually shape the ecosystem. Become indispensable to founders, colleagues, and LPs alike.</li>
</ul><br/> 
<h4 style={{textDecoration:'underline'}}>Early-Stage VC</h4>
<ul>
<li><b>Breaking in</b> — No standard path. CFA/CA helps, but functional depth, sector expertise, and initiative matter more. Proactive outreach, research theses, or pro bono angel investing can open doors.</li>
<li><b>Skills that matter</b> — Building founder rapport, reading business models, spotting opportunities—financial modeling is secondary at the outset.</li>
<li><b>Paths into VC</b> — You can start in deals or functional roles (marketing, HR, ESG, strategy). Early-stage firms value domain knowledge and operational experience as much as deal execution.</li>
<li><b>Decision-making</b> — Early-stage bets = conviction in founders over models. Understanding team dynamics often predicts success better than numbers.</li>
<li><b>Mentorship</b> — Essential. Internal mentors guide deal execution, external mentors help strategic growth, network expansion, and career navigation.</li>
<li><b>Continuous learning</b> — Stay agile. Track trends, sector cycles, and emerging founders to spot opportunities.</li>
</ul>

 

<br/> 



              </div>
              <br />

              
           
<br/>  

<div class="row">
  
<div class="col-md-12"> 
              <h2 class="ignite-ask-me-anything__heading" style={{ fontSize: "30px" }}>Speakers</h2>          <div class="r_btm"></div>
                      
                 
                      <div className="Our_Speakers container">
                        <center>
                          <div className="Speakers_img" style={{ width: '80%' }}>
                          <div className="row">

{this.Speaker1.map((item, i) => {
 if(i<=12) 
 {
  return (
    <div
      className="main_speaker_card col-md-3 col-sm-12 col-lg-3"
      key={i}
    >
      <div className="Scardd">
        <div
          className="s_img"
          onClick={() => this.togglePopUp(item)}
        >
           <center>  <img
            src={item.imgUrl}
            alt={item.name}
            className="img-responsive"
            style={{ borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }}
          />
          </center>
        </div>
        <br />    <div
          className="Speakers_name"
          dangerouslySetInnerHTML={{ __html: item.name }}
        ></div>
        <div
          className="Speakers_post"
          dangerouslySetInnerHTML={{ __html: item.post }}
        ></div>
      </div>
    </div>
  );
 }
 else 
 return (
    <div
      className="main_speaker_card col-md-6 col-sm-12 col-lg-6"
      key={i}
    >
      <div className="Scardd">
        <div
          className="s_img"
          onClick={() => this.togglePopUp(item)}
        >
           <center>  <img
            src={item.imgUrl}
            alt={item.name}
            className="img-responsive"
            style={{ borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }}
          />
          </center>
        </div>
        <br />    <div
          className="Speakers_name"
          dangerouslySetInnerHTML={{ __html: item.name }}
        ></div>
        <div
          className="Speakers_post"
          dangerouslySetInnerHTML={{ __html: item.post }}
        ></div>
      </div>
    </div>
  );
})}
</div>
                          </div>

                        </center>
                      </div>
                 </div>   
                 
        
</div>

            </div>
            <TeamModal
              show={isShow}
              onHide={this.togglePopUp}
              activeItem={this.state.activeItem}
            />
          </div>
        </div>
      </ContentPage>
    );
  }
}

SheShines.propTypes = {
  location: PropTypes.object,
};

export default SheShines;



// WEBPACK FOOTER //
// ./src/pages/IgniteSession15Nov2025/index.js